export var OnlineStates = {
    online: 1,
    offline: 2,
    recovered: 3,
    failure: 4,
};



//////////////////
// WEBPACK FOOTER
// ./src/models/interfaces/OnlineStates.ts
// module id = null
// module chunks = 